import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const deleteMyProfile = createAsyncThunk(
  'companyMaster/deleteMyProfile',
  async (data) => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.post(
        `${BACKEND_URL}/api/delete-my-profile`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      // console.log(error.response.data);
      throw error?.response?.data;
    }
  }
);

const deleteProfileSlice = createSlice({
  name: 'deleteProfile',
  initialState: {
    deleteMyProfileError: null,
    deleteMyProfileLoading: false,
    deleteMyProfileSuccess: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteMyProfile.pending, (state) => {
        state.deleteMyProfileLoading = true;
        state.deleteMyProfileError = null;
      })
      .addCase(deleteMyProfile.fulfilled, (state) => {
        state.deleteMyProfileLoading = false;
        state.deleteMyProfileSuccess = true;
      })
      .addCase(deleteMyProfile.rejected, (state, action) => {
        state.deleteMyProfileError = action.error.message;
        state.deleteMyProfileLoading = false;
      });
  },
});

export default deleteProfileSlice.reducer;
